import { defineComponent } from 'vue';
export default defineComponent({
    name: 'blue-shipping-period-info',
    computed: {
        shipping_period() {
            const date = new Date();
            // myswooop Zeitzone
            date.toLocaleString('de-DE', { timeZone: 'Europe/Berlin' });
            // mo-fr bis 14:00
            if (date.getDay() < 6 && date.getHours() < 14) {
                return 'Dein Paket wird <span class="strong">heute noch verschickt</span>, wenn Du bis 14:00 Uhr bezahlst!<br>';
            }
            // 14:00-00:00, maximal bis donnerstag. Freitag < 14:00 greift obiger case, nach 14:00 Fallback
            if (date.getDay() < 5) {
                return 'Dein Paket wird <span class="strong">direkt morgen verschickt</span>, wenn Du heute noch bezahlst!<br>';
            }
            //fallback (WE, oder Freitag > 14:00)
            return 'Sofort lieferbar – in 2–3 Werktagen bei dir';
        },
    },
});
